// @flow

import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import { Button } from "ui-kit/components";
//import AuthSubmenu from "./submenu";


import "./Header.scss";

import logo from "./img/tilogo.png";

const ccn = getClassName("HeaderAuth");

export class Header extends Component {
  render() {
    return (
      <header className={ccn()}>
        <div className={ccn("container")}>
          <div className={ccn("logo")}>
            <a href={this.props.headerUserLang==="es"?"https://hedgedbitcoin.com/es/":this.props.headerUserLang==="pt"?"https://hedgedbitcoin.com/pt/":this.props.headerUserLang==="zh"?"https://hedgedbitcoin.com/zh/":"https://hedgedbitcoin.com/"}>
              <img src={logo} alt="Logo of Hedged Bitcoin" />
              <span>Hedged Bitcoin</span>
            </a>
          </div>
          <div className={ccn("nav")}>
            {/*<div className={ccn("btnPrimWrap")}>
                          <Button primary={true} small={true} onClick={this.props.btnEvent} className="Button--signup">
                            <FormattedMessage id="hbc.login.header.signup" defaultMessage="Sign Up" />
                          </Button>
                        </div>*/}
            <div className={ccn("btnSecWrap")}>
              <Button secondary={true} small={true} onClick={this.props.btnEvent} className={`Button--login${(localStorage.hbcLang==="ES"?" Button--login--es":"")}`}>
                <FormattedMessage id="hbc.login.header.login" defaultMessage="Log In" />
              </Button>
            </div>
            {/*<AuthSubmenu toClose={this.props.toClose} />*/}
          </div>
        </div>
      </header>
    );
  }
}




// WEBPACK FOOTER //
// ./src/containers/auth/login/header/Header.js